import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  currentStore: {
    sitecolor: "#0A1034",
    menus: [],
    selectedMenu: [],
  },
};

export const commonSlice = createSlice({
  name: "base/common",
  initialState,
  reducers: {
    setCurrentStore: (state, action) => {
      state.currentStore = action.payload;
    },
  },
});

export const { setCurrentStore } = commonSlice.actions;

export default commonSlice.reducer;
